import { render, staticRenderFns } from "./cardsContainerDeatils.vue?vue&type=template&id=22153d4f&scoped=true"
import script from "./cardsContainerDeatils.vue?vue&type=script&lang=ts"
export * from "./cardsContainerDeatils.vue?vue&type=script&lang=ts"
import style0 from "./cardsContainerDeatils.vue?vue&type=style&index=0&id=22153d4f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22153d4f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22153d4f')) {
      api.createRecord('22153d4f', component.options)
    } else {
      api.reload('22153d4f', component.options)
    }
    module.hot.accept("./cardsContainerDeatils.vue?vue&type=template&id=22153d4f&scoped=true", function () {
      api.rerender('22153d4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/cardsContainerDeatils.vue"
export default component.exports